






































import { Component, Vue, Watch } from 'vue-property-decorator'
import FileMenu from '@/apps/open/views/fileCenter/components/FileMenu.vue'
import SlideBar from '@/apps/open/views/fileCenter/components/SlideBar.vue'
import MarkDown from '@/apps/open/views/fileCenter/components/MarkDown.vue'
import DocRate from './components/DocRate.vue'
import axios from 'axios'
import privateDocMenu from './PrivateDocMenu.json'
@Component({
  components: {
    FileMenu,
    SlideBar,
    MarkDown,
    DocRate
  }
})
export default class Cloud extends Vue {
  isFileMenuShow = false
  isOverviewShow = true
  overviewContent = ''
  sliderBarOpeneds: Array<string> = []
  slideBarActive = ''
  breadList = []
  dropdownList = []
  dropdownSelectUrl = ''

  created () {
    this.initBreadcrumb(this.$route)
  }

  beforeRouteUpdate (to: any, from: any, next: any) {
    this.initBreadcrumb(to)
    next()
  }

  mounted () {
    this.slideBarActive = this.$route.path
    window.addEventListener('scroll', this.onBodyScroll, true)
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onBodyScroll, true)
  }

  jumpBreadCrumb (meta: any) {
    this.$router.push({ path: meta.path })
    this.slideBarActive = meta.path
  }

  listenActiveIdx (index: string) {
    this.slideBarActive = index
  }

  onBodyScroll () {
    let scrollTop = document.body.scrollTop + document.documentElement.scrollTop
    let elHeaderHeight = document.getElementsByClassName('el-header')[0].clientHeight
    let elAside = document.getElementsByClassName('el-aside')[0] as HTMLElement
    let elMain = document.getElementsByClassName('el-main')[0] as HTMLElement
    let elBreadCrumb = document.getElementsByClassName('el-breadcrumb')[0] as HTMLElement

    if (scrollTop > elHeaderHeight) {
      elAside.style.position = 'fixed'
      elAside.style.top = '66px'
      elMain.style.marginLeft = '231px'
      elBreadCrumb.style.position = 'fixed'
      elBreadCrumb.style.top = '66px'
    } else {
      elAside.style.position = 'relative'
      elAside.style.top = '0px'
      elMain.style.marginLeft = '0px'
      elBreadCrumb.style.position = 'relative'
      elBreadCrumb.style.top = '0px'
    }
  }

  initBreadcrumb (curRoute: any) {
    let matched = curRoute.matched.filter((item: any) => item.meta.title)
    this.breadList = matched
    this.dropdownList = curRoute.meta.aimtilelist
  }

  initOverviewContent () {
    let mdfileUrl: string = '/mdfile/filecenter' + this.$route.meta.mdfilepath
    axios.get(mdfileUrl).then(response => { this.overviewContent = response.data })
  }

  dropdownItemOnclick (index: number) {
    this.dropdownSelectUrl = '#s' + index
  }

  quickStartMenu = [
    {
      path: '/docs/cloud/join',
      name: '快速入门',
      icon: '',
      children: [
        {
          path: '/docs/cloud/join/platform-overview',
          name: '平台概述',
          icon: ''
        },
        {
          path: '/docs/cloud/join/access-know',
          name: '接入须知',
          icon: ''
        },
        {
          path: '/docs/cloud/join/apply-process',
          name: '申请流程',
          icon: ''
        },
        {
          path: '/docs/cloud/join/create-cloudapp',
          name: '创建应用',
          icon: ''
        },
        {
          path: '/docs/cloud/join/app-config',
          name: '应用设置',
          icon: ''
        },
        {
          path: '/docs/cloud/join/apply-permission',
          name: '权限申请',
          icon: ''
        },
        {
          path: '/docs/cloud/join/ip-list',
          name: 'IP白名单',
          icon: ''
        },
        {
          path: '/docs/cloud/join/domain-list',
          name: '域名白名单',
          icon: ''
        },
        {
          path: '/docs/cloud/join/callback-address',
          name: '回调地址',
          icon: ''
        },
        {
          path: '/docs/cloud/join/return-code',
          name: '全局返回码说明',
          icon: ''
        }
      ]
    }
  ]

  adminCenterConfig = [
    {
      path: '/docs/cloud/basic-ability/admin-center',
      name: '管理中心配置',
      icon: '',
      children: [
        {
          path: '/docs/cloud/basic-ability/admin-center/create-app',
          name: '应用创建',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/admin-center/apply-permission',
          name: '权限申请',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/admin-center/basic-config',
          name: '基本设置',
          icon: ''
        }
      ]
    }
  ]

  accountOauthMenu = [
    {
      path: '/docs/cloud/basic-ability/account-oauth',
      name: '使用WPS账号授权登录',
      icon: '',
      children: [
        {
          path: '/docs/cloud/basic-ability/account-oauth/access-know',
          name: '接入须知',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/api-list',
          name: 'Api列表',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/java-access',
          name: 'Java版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/go-access',
          name: 'Go版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/python-access',
          name: 'Python版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/php-access',
          name: 'Php版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/js-access',
          name: 'Js版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/account-oauth/cplug-access',
          name: 'C插件接入',
          icon: ''
        }
      ]
    }
  ];

  wpsPayMenu = [
    {
      path: '/docs/cloud/basic-ability/wps-pay',
      name: 'WPS支付',
      icon: '',
      children: [
        {
          path: '/docs/cloud/basic-ability/wps-pay/access-know',
          name: '接入须知',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/h5-access',
          name: 'h5页面接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/api-list',
          name: 'Api列表',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/java-access',
          name: 'Java版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/go-access',
          name: 'Go版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/python-access',
          name: 'Python版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/php-access',
          name: 'Php版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/wps-pay/js-access',
          name: 'Js版接入',
          icon: ''
        }
      ]
    }
  ];

  appOauthMenu = [
    {
      path: '/docs/cloud/basic-ability/app-oauth',
      name: '第三方应用授权',
      icon: '',
      children: [
        {
          path: '/docs/cloud/basic-ability/app-oauth/api-list',
          name: 'Api列表',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/app-oauth/signature',
          name: 'Api签名说明',
          icon: ''
        },
        {
          path: '/docs/cloud/basic-ability/app-oauth/oauth-change',
          name: '授权地址变更',
          icon: ''
        }
      ]
    }
  ];

  cloudFileManageMenu = [
    {
      path: '/docs/cloud/cloudfile-ability/manage',
      name: '管理云文档文件',
      icon: '',
      children: [
        {
          path: '/docs/cloud/cloudfile-ability/manage/access-know',
          name: '接入须知',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/manage/api-list',
          name: 'Api列表',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/manage/java-access',
          name: 'Java版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/manage/go-access',
          name: 'Go版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/manage/python-access',
          name: 'Python版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/manage/php-access',
          name: 'Php版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/manage/js-access',
          name: 'Js版接入',
          icon: ''
        }
      ]
    }
  ];

  cloudFileObtainMenu = [
    {
      path: '/docs/cloud/cloudfile-ability/obtain',
      name: '获取云文档文件',
      redirect: '/docs/cloud/cloudfile-ability/obtain/file-select',
      icon: '',
      children: [
        {
          path: '/docs/cloud/cloudfile-ability/obtain/file-select',
          name: '文件选择器',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/obtain/api-list',
          name: 'Api列表',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/obtain/java-access',
          name: 'Java版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/obtain/go-access',
          name: 'Go版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/obtain/python-access',
          name: 'Python版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/obtain/php-access',
          name: 'Php版接入',
          icon: ''
        },
        {
          path: '/docs/cloud/cloudfile-ability/obtain/js-access',
          name: 'Js版接入',
          icon: ''
        }
      ]
    }
  ];

  downloadResourceMenu = [
    {
      path: '/docs/cloud/download-resource',
      name: '资源下载',
      icon: '',
      children: [
        {
          path: '/docs/cloud/download-resource/design',
          name: '设计资源',
          icon: ''
        }
      ]
    }
  ];

  errorCode = [{
    path: '/docs/cloud/error-code',
    name: '常见错误码',
    icon: ''
  }]

  FAQ = [{
    path: '/docs/cloud/FAQ',
    name: '常见问题',
    icon: ''
  }]

  caseCenter = [{
    path: '/docs/cloud/case-solution',
    name: '案例解决方案',
    icon: ''
  }]

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get fileCenterMenu () {
    const publicDocMenu = [
      ...this.caseCenter,
      ...this.adminCenterConfig,
      ...this.accountOauthMenu,
      ...this.cloudFileManageMenu,
      ...this.cloudFileObtainMenu,
      ...this.wpsPayMenu,
      ...this.downloadResourceMenu,
      ...this.errorCode,
      ...this.FAQ
    ]
    return this.isPrivate ? privateDocMenu.kdocs : publicDocMenu
  }
}
